// Une série de l'app qui se remplit (reps, kilos, centièmes), avec la ligne
// « Dernière : … » et le badge « ↑ Progression » ; la série suivante attend,
// avec l'objectif proposé par Gym'Coach. D'après screens/training/Exercice.js.
import React from "react";
import Apercu from "./Apercu";
import { SERIES_TIRAGE } from "./donneesDemo";

function Case({ vide, plein, reps = false, i }) {
	return (
		<span className={`gs-a-case${reps ? " gs-a-case--reps" : ""}`} style={{ "--i": i }}>
			<i className="gs-a-vide">{vide}</i>
			<i className="gs-a-plein">{plein}</i>
		</span>
	);
}

export default function ApercuSerie({ boucle = false, avecSuivante = true, className = "" }) {
	const s = SERIES_TIRAGE[0];
	return (
		<Apercu
			boucle={boucle}
			className={className}
			description={`Série de tirage horizontal : ${s.reps} × 82,5 kg, en progression par rapport à ${s.derniere}.`}
		>
			<div className="gs-a-carte gs-a-carte--sombre">
				<div className="gs-a-lbl">Tirage horizontal</div>
				<div className="gs-a-serie">
					<div className="gs-a-serie-haut">
						<span>Série {s.numero}</span>
						<span className="gs-a-badge gs-anim-pop">↑ Progression</span>
					</div>
					<div className="gs-a-cases">
						<Case vide="0" plein={s.reps} reps i={0} />
						<Case vide="0" plein={s.kg} i={1} />
						<span className="gs-a-point">.</span>
						<Case vide="00" plein={s.dec} i={2} />
					</div>
					<div className="gs-a-derniere">
						<span>Dernière : {s.derniere}</span>
						<span>RPE {s.rpe}</span>
					</div>
				</div>
				{avecSuivante && (
					<div className="gs-a-serie" style={{ borderLeftColor: "rgba(255,255,255,.18)" }}>
						<div className="gs-a-serie-haut">
							<span>Série 2</span>
						</div>
						<div className="gs-a-cases">
							<span className="gs-a-case gs-a-case--reps">
								<i style={{ color: "rgba(48,164,154,.45)" }}>0</i>
							</span>
							<span className="gs-a-case">
								<i style={{ color: "rgba(255,255,255,.25)" }}>0</i>
							</span>
							<span className="gs-a-point">.</span>
							<span className="gs-a-case">
								<i style={{ color: "rgba(255,255,255,.25)" }}>00</i>
							</span>
						</div>
						<div className="gs-a-objectif">
							<span className="gs-a-objectif-source">Gym'Coach · </span>Objectif : 8 × 82,5 kg · RPE 8
						</div>
					</div>
				)}
			</div>
		</Apercu>
	);
}
